import React from 'react';
import { ExternalLink } from 'lucide-react';
import { IITH_LEADERSHIP } from './iithLeadership';
import { IITH, SERIF, SANS } from './iithBrand';

export default function LeadershipSection() {
  return (
    <section className="py-16 sm:py-20" style={{ background: IITH.mist }} data-testid="iith-leadership">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <p className="text-[11px] uppercase tracking-[0.22em]" style={{ color: IITH.saffron, fontFamily: SANS }}>
          Leadership
        </p>
        <h2 className="text-3xl sm:text-4xl font-semibold mt-2" style={{ fontFamily: SERIF, color: IITH.navy }}>
          Guiding campus healthcare
        </h2>
        <p className="mt-2 text-sm max-w-2xl" style={{ color: IITH.navyMid, fontFamily: SANS }}>
          Profiles from the official{' '}
          <a href="https://hospital.iith.ac.in/" target="_blank" rel="noreferrer" className="underline underline-offset-2">
            IIT Hyderabad Hospital
          </a>{' '}
          site.
        </p>

        <div className="mt-10 grid sm:grid-cols-3 gap-6">
          {IITH_LEADERSHIP.map((p) => (
            <article
              key={p.name}
              className="bg-white rounded-2xl overflow-hidden border border-zinc-200/80 shadow-sm"
            >
              <div className="aspect-[4/5] overflow-hidden bg-zinc-100">
                <img
                  src={p.photo}
                  alt={p.name}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <p className="text-[11px] uppercase tracking-wider" style={{ color: IITH.saffron }}>{p.role}</p>
                <h3 className="text-lg font-semibold mt-1" style={{ fontFamily: SERIF, color: IITH.navy }}>
                  {p.name}
                </h3>
                <p className="text-sm mt-0.5" style={{ color: IITH.navyMid }}>{p.title}</p>
                <p className="text-sm mt-3 leading-relaxed text-zinc-600">{p.bio}</p>
                <a
                  href={p.profileUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium"
                  style={{ color: IITH.navy }}
                >
                  View on hospital.iith.ac.in <ExternalLink className="h-3.5 w-3.5" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
